/**
 * @generated SignedSource<<8e3d1334856ab741309b990a45e5f46d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type chatUserTrackerQuery$variables = {
  nakamaID: string;
};
export type chatUserTrackerQuery$data = {
  readonly userFromNakamaID: {
    readonly avatarURL: string;
    readonly id: string;
    readonly nakamaID: string;
    readonly username: string;
    readonly usernameID: string;
  } | null;
};
export type chatUserTrackerQuery = {
  response: chatUserTrackerQuery$data;
  variables: chatUserTrackerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nakamaID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "nakamaID",
        "variableName": "nakamaID"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "userFromNakamaID",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usernameID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avatarURL",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nakamaID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chatUserTrackerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "chatUserTrackerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "283abd879dddd95a18e41edb5da2e08e",
    "id": null,
    "metadata": {},
    "name": "chatUserTrackerQuery",
    "operationKind": "query",
    "text": "query chatUserTrackerQuery(\n  $nakamaID: String!\n) {\n  userFromNakamaID(nakamaID: $nakamaID) {\n    id\n    username\n    usernameID\n    avatarURL\n    nakamaID\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f3bcc588d171127b491b6b87172c62f";

export default node;
